import(/* webpackMode: "eager", webpackExports: ["CatchAllPageClient"] */ "/opt/atlassian/pipelines/agent/build/packages/app/src/app/[...slug]/page.client.tsx");
